// src/utils/userUtils.js
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

// Kullanıcının temel profil bilgilerini getir
export const getUserProfile = async (userId) => {
  if (!userId) return null;
  try {
    const docRef = doc(db, "users", userId);
    const snapshot = await getDoc(docRef);
    if (!snapshot.exists()) return null;

    const data = snapshot.data();
    return {
      id: userId,
      username: data.username || "Bilinmeyen",
      examType: data.examType || "Bilinmiyor",
      photoURL: data.photoURL || null,
      followers: Array.isArray(data.followers) ? data.followers : [],
      following: Array.isArray(data.following) ? data.following : [],
    };
  } catch (error) {
    console.error("❌ Kullanıcı profili alınamadı:", error);
    return null;
  }
};

// Takipçi ve takip edilen listesini getir
export const getFollowersAndFollowing = async (userId) => {
  if (!userId) return { followers: [], following: [] };
  try {
    const docRef = doc(db, "users", userId);
    const snapshot = await getDoc(docRef);
    if (!snapshot.exists()) return { followers: [], following: [] };

    const data = snapshot.data();
    return {
      followers: Array.isArray(data.followers) ? data.followers : [],
      following: Array.isArray(data.following) ? data.following : [],
    };
  } catch (error) {
    console.error("Takip verileri alınamadı:", error);
    return { followers: [], following: [] };
  }
};

// Bir kullanıcı diğerini takip ediyor mu kontrol et
export const isFollowing = async (currentUserId, targetUserId) => {
  if (!currentUserId || !targetUserId) return false;
  try {
    const { following } = await getFollowersAndFollowing(currentUserId);
    return following.includes(targetUserId);
  } catch (error) {
    console.error("Takip durumu kontrol edilemedi:", error);
    return false;
  }
};